"use client";
import React from "react";
import { motion } from "framer-motion";
import { Caveat } from "next/font/google";
import Image from "next/image";

const caveat = Caveat({ subsets: ["latin"], weight: ["400", "700"], display: "swap" });

export default function IndustrySplitContent({ section }) {
  return (
    <section className="py-24 px-6 sm:px-12 lg:px-24 relative overflow-visible">
      <div className="container mx-auto">
        <div>
          <h2 className={`text-5xl md:text-7xl font-bold mb-20 leading-tight text-white`}>
            From the <span className="border-b-4 border-orange-400 pb-1">{section.title.split(" ").slice(1, 2)}</span> to the <span className={`text-orange-500 ${caveat.className}`}>{section.title.split(" ").slice(-1)}</span>
          </h2>

          <div className="grid lg:grid-cols-12 gap-16 items-start">
            <motion.div
              className="lg:col-span-7 relative"
            >
              <div className="space-y-6 mb-12">
                <p className="text-xl text-gray-300 leading-relaxed">
                  <strong className="text-white">{section.items[0].text.split(" ").slice(0, 3).join(" ")}</strong>
                  {section.items[0].text.substring(section.items[0].text.indexOf("centralized") - 3)}
                </p>
                <p className="text-xl text-gray-300 leading-relaxed">
                  <strong className="text-white">Turn leads into sales</strong> with ease, and send your clients customized quotations describing your offer.
                </p>
              </div>
              <div className="rounded-2xl overflow-hidden shadow-xl border border-white/10 relative z-10 bg-white/5">
                <Image 
                  src={section.items[0].image} 
                  width={700}
                  height={450}
                  sizes="(max-width: 1024px) 100vw, 60vw"
                  className="w-full h-auto object-cover" 
                  alt="Feature detail" 
                />
              </div>
              <div className="absolute -bottom-20 -right-20 w-[300px] h-[300px] opacity-10 d-none d-lg-block pointer-events-none rotate-12">
                <Image
                  src="/odoo/arrows/grey_arrow_dot_03.svg"
                  fill
                  className="object-contain"
                  alt=""
                />
              </div>
            </motion.div>

            <motion.div
              className="lg:col-span-4 lg:mt-32"
            >
              <div className="rounded-2xl overflow-hidden shadow-xl mb-8 border border-white/10 bg-white/5 relative">
                <Image 
                  src={section.items[1].image} 
                  width={400}
                  height={550}
                  sizes="(max-width: 1024px) 100vw, 35vw"
                  className="w-full h-auto object-cover" 
                  alt="Secondary feature detail" 
                />
              </div>
              <p className="text-lg text-gray-300 leading-relaxed">
                <strong className="text-white">Invoice clients</strong> on your terms, based on time and material, fixed rates, or milestones.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
